import React, { useState, useEffect, useRef } from 'react'
import { useAuth } from '../../../contexts/AuthContext'
import { useOnboardingIntent } from './useOnboardingIntent'
import { IntentPickerModal } from './IntentPickerModal'

export const IntentPickerController: React.FC = () => {
  const { onboardingPickerRequestId } = useAuth()
  const { shouldShow } = useOnboardingIntent()
  const [isOpen, setIsOpen] = useState(false)
  const prevRequestId = useRef(onboardingPickerRequestId)

  useEffect(() => {
    const explicitRequest = onboardingPickerRequestId > prevRequestId.current
    prevRequestId.current = onboardingPickerRequestId

    if (explicitRequest || shouldShow) {
      setIsOpen(true)
    }
  }, [shouldShow, onboardingPickerRequestId])

  return (
    <IntentPickerModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
  )
}
